const blocks = require("./blocks");
const exchange = require("./exchange");
const minichef = require("./minichef");
const masterchef = require("./masterchef");
const masterchefV2 = require("./masterchef-v2");

module.exports = {
  ...blocks,
  ...exchange,
  ...minichef,
  ...masterchef,
  ...masterchefV2
};
